import { render, staticRenderFns } from "./VideoPopUp.vue?vue&type=template&id=0c07e2ad&"
import script from "./VideoPopUp.vue?vue&type=script&lang=ts&"
export * from "./VideoPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports